/* global QuickLoad */
const { extend } = require('app/src/extend_DO_NOT_USE');

const $ = require('jquery');
const React = require('react');
const ReactDOM = require('@trello/react-dom-wrapper');
const Auth = require('app/scripts/db/auth');
const Backbone = require('app/scripts/lib/backbone');
const EventsMixin = require('app/scripts/lib/events-mixin');
const Hearsay = require('hearsay');
const { currentModelManager } = require('./currentModelManager');
const { Key, registerShortcut, Scope } = require('@trello/keybindings');
const PostRender = require('app/scripts/views/lib/post-render');
const Promise = require('bluebird');
const { Storage } = require('@trello/storage');
const { logError } = require('app/scripts/debug/log-error');
const Util = require('app/scripts/lib/util');
const _ = require('underscore');
const { mixin } = require('app/scripts/lib/mixin_DO_NOT_USE');
const l = require('app/scripts/lib/localize');
const { featureFlagClient } = require('@trello/feature-flag-client');
const assert = require('app/scripts/lib/assert');
const f = require('effing');
const ApiError = require('app/scripts/network/api-error');
const { ErrorViews } = require('app/common/data/error-views');
const getQueryParamByKey = require('app/scripts/lib/util/url/get-query-param-by-key');
const getExperiment = require('app/scripts/lib/experiments/simple-test');
const { navigateFactory } = require('app/scripts/controller/navigate');
const { track, trackPageview } = require('@trello/analytics');
const { client, clientVersion } = require('@trello/config');
const { defaultRouter, RouteNames } = require('app/common/router');
const updateTimezone = require('app/scripts/lib/update-timezone');
const memberIdStorageKey = 'idMe';
const { defaultStore } = require('app/gamma/src/defaultStore');
const {
  navigateStart,
  navigateStop,
} = require('app/gamma/src/modules/state/ui/navigating');
const {
  addBoardToRecent,
} = require('app/gamma/src/modules/state/ui/boards-menu');
const { removeOverlay } = require('app/gamma/src/modules/state/ui/overlay');
const {
  clearSearchQuery,
} = require('app/gamma/src/modules/state/models/search');
const {
  toggleBoardsMenu,
} = require('app/gamma/src/modules/state/ui/boards-menu');

const headerLoad = function (methodName, eventName) {
  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const ModelLoader = require('app/scripts/db/model-loader');
  const actualLoad = Auth.isLoggedIn()
    ? ModelLoader['for']('header', methodName)
    : Promise.resolve(null);
  return actualLoad
    .then(function () {
      return ModelLoader.triggerWaits(eventName);
    })
    ['catch'](ApiError, function (err) {
      logError(
        new Error(
          'headerLoad ApiError, err = ' +
            err +
            ', err.constructor.name = ' +
            err.constructor.name,
        ),
      );
      throw err;
    })
    ['catch'](ApiError.Unauthenticated, function (err) {
      // We've previously tried logging people out when they get an unauthorized error,
      // while loading the header, under the assumption that they've somehow got a bad cookie.
      // Unfortunately we've had some firefox users reporting that this is logging them out
      // when it shouldn't be
      return console.log('Error trying to load header');
    })
    .done();
};

const Controller = (function (superClass) {
  // eslint-disable-next-line no-use-before-define
  extend(Controller, superClass);

  // eslint-disable-next-line no-shadow
  function Controller() {
    return Controller.__super__.constructor.apply(this, arguments);
  }

  Controller.prototype.initialize = function () {
    this._savedTitle = '';
    this.currentModel = currentModelManager.currentModel;

    return this.currentModel;
  };

  Controller.prototype.getQueryParamByKey = getQueryParamByKey;

  Controller.prototype.start = function () {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const JoinOnConfirm = require('app/scripts/lib/join-on-confirm');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const ModelLoader = require('app/scripts/db/model-loader');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const rpc = require('app/scripts/network/rpc');
    rpc.on(
      'subscription_unauthorized',
      (function (_this) {
        return function (modelType, idModel) {
          const shouldDisplayError = function () {
            switch (modelType) {
              case 'Board':
                return this.onBoardView(idModel);
              case 'Organization':
                return this.onOrganizationView(idModel);
              default:
                return false;
            }
          }.call(_this);
          if (shouldDisplayError) {
            const errorType =
              modelType === 'Board'
                ? ErrorViews.BOARD_NOT_FOUND
                : ErrorViews.NOT_FOUND;
            return _this.displayErrorPage({
              errorType: errorType,
            });
          }
        };
      })(this),
    );
    headerLoad('loadHeaderData', 'headerData');
    setTimeout(f(headerLoad, 'loadBoardsMenuData', 'boardsData'), 500);
    if (Auth.isLoggedIn()) {
      ModelLoader.await('headerData')
        .then(function () {
          // set idMe in localStorage
          Storage.set(memberIdStorageKey, Auth.myId());

          // LaunchDarkly - Once we have the header data
          // we can send a more informative user object to LD
          return featureFlagClient.refineUserData({
            channel: Auth.me().get('channels')?.active,
            idOrgs: Auth.me()?.get('idOrganizations') ?? [],
            emailDomain: Auth.me()?.get('email')?.split('@')[1] ?? '',
            isClaimable: Auth.me()
              ?.get('logins')
              ?.some((login) => login.claimable),
            idEnterprises:
              Auth.me()
                ?.get('enterprises')
                ?.map((enterprise) => enterprise.id) ?? [],
            orgs: ['[Redacted]'],
            clientVersion: clientVersion,
            head: client.head,
            version: client.version,
          });
        })
        .done();
    } else {
      // Have the user object reflect a user that isn't logged in
      featureFlagClient.refineUserData({
        channel: void 0,
        idOrgs: [],
        emailDomain: '',
        isClaimable: false,
        idEnterprises: [],
        orgs: [],
        clientVersion: clientVersion,
        head: client.head,
        version: client.version,
      });
    }
    const onShortcut = (function (_this) {
      return function () {
        if (_this.onAnyBoardView()) {
          _this.navigate('shortcuts/overlay');
          _this.shortcutsOverlayPage();
        } else {
          _this.navigate('/shortcuts', {
            trigger: true,
          });
        }
        return track('Keyboard Shortcuts', 'Shortcuts page');
      };
    })(this);

    registerShortcut(onShortcut, {
      scope: Scope.Global,
      key: Key.QuestionMark,
    });

    return JoinOnConfirm.autoJoin()
      .then(function (didJoin) {
        if (didJoin) {
          // We can't trust that the stuff that we quickloaded is
          // going to be accurate, or that we'll catch the updates
          // when we subscribe, so just dump it to be safe
          return QuickLoad.clear();
        }
      })
      ['return']();
  };

  Controller.prototype.viewType = 'none';

  Controller.prototype.topLevelView = function (viewType, model, options) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const ApplicationView = require('app/scripts/views/application-view');
    // eslint-disable-next-line eqeqeq
    if (this.applicationView == null) {
      this.applicationView = new ApplicationView();
    }
    // eslint-disable-next-line eqeqeq
    if (options == null) {
      options = {};
    }
    // eslint-disable-next-line eqeqeq
    if (options.modelCache == null) {
      options.modelCache = this.getCurrentModelCache();
    }
    return this.applicationView.subview(viewType, model, options);
  };

  Controller.prototype.existingTopLevelView = function (viewType, model) {
    return this.applicationView.existingSubview(viewType, model);
  };

  Controller.prototype.existingTopLevelViewOrUndefined = function (
    viewType,
    model,
  ) {
    return this.applicationView?.existingSubviewOrUndefined(viewType, model);
  };

  Controller.prototype.title = function (title) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const FavIcon = require('app/scripts/lib/favicon');

    let fullTitle;
    // eslint-disable-next-line eqeqeq
    if (title != null) {
      this._savedTitle = title;
    }
    const unreadNotifications =
      Auth.isLoggedIn() && Auth.me()?.unreadNotifications();

    fullTitle = '';
    if (this._savedTitle?.length > 0) {
      fullTitle += this._savedTitle + ' | ';
    }
    fullTitle += 'Trello';
    // eslint-disable-next-line eqeqeq
    if (window.fluid != null) {
      // If someone happens to be using fluid, update their dockBadge
      // http://fluidapp.com/developer/
      window.fluid.dockBadge = unreadNotifications ? unreadNotifications : null;
    }
    return (document.title = fullTitle);
  };

  Controller.prototype.setLocation = function (arg) {
    let location, options, title;
    (title = arg.title), (location = arg.location), (options = arg.options);
    // eslint-disable-next-line eqeqeq
    if (title != null) {
      this.title(title);
    }
    if (location) {
      if (/^#/.test(location)) {
        location = location.substr(1);
      }
      this.navigate(location, options);
      this.location = location;
    }
  };

  Controller.prototype.showingCalendar = function (boardView) {
    return (
      // eslint-disable-next-line eqeqeq
      (boardView != null ? boardView.$('.calendar-wrapper').length : void 0) > 0
    );
  };

  Controller.prototype.showingMap = function (boardView) {
    return (
      // eslint-disable-next-line eqeqeq
      (boardView != null ? boardView.$('.map-wrapper').length : void 0) > 0
    );
  };

  Controller.prototype.setBoardLocation = function (
    idBoard,
    section,
    extra,
    options,
  ) {
    // eslint-disable-next-line eqeqeq
    if (section == null) {
      section = '';
    }
    // eslint-disable-next-line eqeqeq
    if (extra == null) {
      extra = [];
    }
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const ModelCache = require('app/scripts/db/model-cache');
    const name = ModelCache.get('Board', idBoard).get('name');
    this.setLocation({
      title: name,
      location: this.getBoardUrl(idBoard, section, extra),
      options: options,
    });
  };

  Controller.prototype.saveMemberBoardProfileLocation = function (
    member,
    idBoard,
  ) {
    return this.setLocation({
      title: member.get('fullName'),
      location: this.getMemberBoardProfileUrl(member.get('username'), idBoard),
    });
  };

  Controller.prototype.isOnSearchPage = function () {
    return this.currentPage === 'search';
  };

  Controller.prototype.onAnyOrganizationView =
    currentModelManager.onAnyOrganizationView;

  Controller.prototype.onOrganizationView =
    currentModelManager.onOrganizationView;

  Controller.prototype.onAnyBoardView = currentModelManager.onAnyBoardView;

  Controller.prototype.onBoardView = currentModelManager.onBoardView;

  Controller.prototype.getCurrentBoard = currentModelManager.getCurrentBoard;

  // This is gross, but slightly better than having a global 'boardView' variable
  Controller.prototype.getCurrentBoardView = function () {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const BoardView = require('app/scripts/views/board/board-view');
    return this.existingTopLevelViewOrUndefined(
      BoardView,
      this.getCurrentBoard(),
    );
  };

  Controller.prototype.getCurrentModelCache = function () {
    return this.currentModelCache;
  };

  Controller.prototype.saveBoardsView = function () {
    // eslint-disable-next-line eqeqeq
    if (this.savedBoardViewInformation != null || !this.onAnyBoardView()) {
      return;
    }
    this.savedBoardViewInformation = {
      idBoard: this.currentModel.get().id,
      // eslint-disable-next-line no-useless-escape
      path: /\/b\/[^\/]*\/(.*)/.exec(this.location)[1],
    };
  };

  Controller.prototype.loadBoardsView = function () {
    if (!this.savedBoardViewInformation) {
      return;
    }

    const { idBoard, path } = this.savedBoardViewInformation;
    this.boardView(idBoard, path);

    return delete this.savedBoardViewInformation;
  };

  Controller.prototype.clearPreviousView = function (options) {
    // eslint-disable-next-line eqeqeq
    if (options == null) {
      options = {};
    }
    // eslint-disable-next-line eqeqeq
    if (options.shallow == null) {
      options.shallow = false;
    }
    // eslint-disable-next-line eqeqeq
    if (options.isNextViewReact == null) {
      options.isNextViewReact = false;
    }
    const { shallow, isNextViewReact } = options;

    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const AttachmentViewer = require('app/scripts/views/internal/attachment-viewer');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const Dialog = require('app/scripts/views/lib/dialog');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const PluginModal = require('app/scripts/views/lib/plugin-modal');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const PopOver = require('app/scripts/views/lib/pop-over');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const SearchState = require('app/scripts/view-models/search-state');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const Board = require('app/scripts/models/board');

    // shallow = true is for singlespa page transitions
    if (shallow) {
      SearchState.setQuery('');
      PopOver.hide();
      PluginModal.close();
      if (Dialog.isVisible) {
        Dialog.hide(true);
      }
      return;
    }
    defaultStore.dispatch(toggleBoardsMenu(false));
    defaultStore.dispatch(removeOverlay());
    defaultStore.dispatch(clearSearchQuery());
    ReactDOM.unmountComponentAtNode(document.getElementById('content'));
    SearchState.setQuery('');
    // eslint-disable-next-line eqeqeq
    if (this.applicationView != null) {
      this.applicationView.remove();
    }
    delete this.applicationView;
    PopOver.hide();
    PluginModal.close();
    if (Dialog.isVisible) {
      Dialog.hide(true);
    }
    if (!isNextViewReact) {
      ReactDOM.unmountComponentAtNode(document.getElementById('content'));
      $('#content').html('');
    }
    $('body').scrollTop('0');
    $('#trello-root')
      .removeClass(
        'body-single-column body-tabbed-page body-search-page body-board-view body-custom-board-background body-custom-board-background-tiled body-light-board-background body-dark-board-background body-ambiguous-board-background body-default-header body-hide-header',
      )
      .css(
        {
          'background-image': '',
          'background-color': '',
        },
        AttachmentViewer.clear(),
      );
  };

  // Call this *after* loading data, before displaying
  // (So the transition is instant)
  Controller.prototype.setViewType = function (modelOrString) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const FavIcon = require('app/scripts/lib/favicon');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const ModelCache = require('app/scripts/db/model-cache');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const SidebarState = require('app/scripts/view-models/sidebar-state');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const Board = require('app/scripts/models/board');
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const {
      isInspirationBoard,
    } = require('app/scripts/views/onboarding/helpers');
    if (this.currentModel.get() instanceof Board) {
      this.currentModel.get().markAsViewed();
    }
    if (_.isString(modelOrString)) {
      this.currentModelCache = ModelCache;
      this.currentModel.set(null);
    } else {
      this.currentModelCache = modelOrString.modelCache;
      this.currentModel.set(modelOrString);
    }
    this.currentPage = modelOrString;
    if (this.currentModel.get() instanceof Board) {
      const board = this.currentModel.get();
      this.waitForId(board, function () {
        // The right thing to do would be to have all this accounting-for-
        // views code observe the current location of the Controller, instead
        // of having the Controller know about that much. A good project
        // for a future refactor.
        board.markAsViewed();
        SidebarState.pushBoard(board.id);
        if (!isInspirationBoard(board.id)) {
          $('#js-inspiration-popover-mount').remove();
        }
        return defaultStore.dispatch(
          addBoardToRecent({
            id: board.id,
          }),
        );
      });
    } else {
      FavIcon.setBackground({
        useDefault: true,
      });
      $('#js-inspiration-popover-mount').remove();
    }
  };

  /**
   * Hey look! We're duplicating code. In actually the *third* place.
   * isWebClientPage has this check, it's defined in the route above,
   * and we have it here too.
   * Turns out Backbone's router gives you *no* inspection ability. It
   * doesn't return any routes that you create. The method that converts
   * routes into regular expressions is private. Even if you create a named
   * route, there's no way to retrive the Backbone route object for that.
   * So! When we stop using Backbone's router, make sure to come back and
   * fix this.
   */
  Controller.prototype.onCardView = function () {
    // eslint-disable-next-line no-useless-escape
    return /^c\/[a-zA-Z0-9]{8}(\/[^\/]+)?/.test(Backbone.history.fragment);
  };

  Controller.prototype.organizationById = function (idOrganization) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const ModelLoader = require('app/scripts/db/model-loader');
    return ModelLoader['for']('top-level', 'loadOrgNameById', idOrganization)
      .then(
        (function (_this) {
          return function (name) {
            return _this.organizationBoardsView(name);
          };
        })(this),
      )
      ['catch'](
        ApiError,
        (function (_this) {
          return function () {
            return _this.displayErrorPage();
          };
        })(this),
      )
      .done();
  };

  Controller.prototype.getSpinner = function () {
    defaultStore.dispatch(navigateStart());
    return Promise.resolve().disposer(function () {
      defaultStore.dispatch(navigateStop());
    });
  };

  /**
   * Focus the content, so it can immediately be scrolled
   * with the arrow keys.  The tabindex is necessary
   * to make the div focusable. This causes a style recalc/reflow
   * so deferring it via setTimeout
   */
  Controller.prototype.focusContent = function () {
    return _.defer(() => {
      $('#content').attr('tabindex', '-1').focus();
    });
  };

  return Controller;
})(Backbone.Router);

mixin(EventsMixin, Controller);

const backboneNavigate = Backbone.History.prototype.navigate;

_.extend(Backbone.History.prototype, {
  navigate: function (path, options) {
    updateTimezone();
    const navigate = navigateFactory(
      backboneNavigate.bind(this),
      this.location.pathname,
      (fragment) => trackPageview(fragment || 'boards'),
    );
    return navigate(path, options);
  },
});

const {
  ERROR_PAGE,
  ENTERPRISE_ADMIN,
  ENTERPRISE_ADMIN_TAB,
  POWER_UP_ADMIN,
  POWER_UP_EDIT,
  POWER_UP_PUBLIC_DIRECTORY,
  CREATE_FIRST_TEAM,
  SHORTCUTS,
  SHORTCUTS_OVERLAY,
  BLANK,
  SELECT_ORG_TO_UPGRADE,
  SELECT_TEAM_TO_UPGRADE,
  SEARCH,
  TEMPLATES_SUBMIT,
  TEMPLATES,
  TEMPLATES_RECOMMEND,
} = require('@trello/routes');
const { userOrOrgRoutes } = require('./user-or-org-routes');

const components = [
  require('./display-board'),
  require('./urls'),
  require('./header'),
  require('./footer'),
  require('./quick-boards'),
  {
    routes: [
      [POWER_UP_ADMIN, 'powerUpAdmin'],
      [POWER_UP_EDIT, 'editPowerUpPage'],
      [POWER_UP_PUBLIC_DIRECTORY, 'publicDirectory'],
    ],
    powerUpAdmin: function (...args) {
      return import(
        /* webpackChunkName: "powerup-admin-page" */
        './powerupAdminPage'
      ).then(({ powerupAdminPage }) => powerupAdminPage(...args));
    },
    editPowerUpPage: function (...args) {
      import(
        /* webpackChunkName: "powerup-edit-powerup-page" */
        './powerupEditPowerUpPage'
      ).then(({ powerupEditPowerUpPage }) => powerupEditPowerUpPage(...args));
    },
    publicDirectory: function (...args) {
      import(
        /* webpackChunkName: "powerup-public-directory-page" */
        './powerupPublicDirectoryPage'
      ).then(({ powerupPublicDirectoryPage }) =>
        powerupPublicDirectoryPage(...args),
      );
    },
  },
  {
    routes: [
      [CREATE_FIRST_TEAM, 'createFirstTeamPage'],
      [SHORTCUTS, 'shortcutsPage'],
      [SHORTCUTS_OVERLAY, 'shortcutsOverlayPage'],
      [BLANK, 'blankPage'],
      [SELECT_ORG_TO_UPGRADE, 'selectOrgToUpgradePage'],
      [SELECT_TEAM_TO_UPGRADE, 'selectTeamToUpgradePage'],
      [SEARCH, 'searchPage'],
      [TEMPLATES_SUBMIT, 'templatesGallerySubmitPage'],
      [TEMPLATES, 'templatesGalleryPublicPage'],
      [TEMPLATES_RECOMMEND, 'templatesGalleryPublicPage'],
    ],
    createFirstTeamPage: function (...args) {
      return import(
        /* webpackChunkName: "create-first-team-page" */ './createFirstTeamPage'
      ).then(({ createFirstTeamPage }) => {
        return createFirstTeamPage.call(this, ...args);
      });
    },
    shortcutsPage: function (...args) {
      return import(
        /* webpackChunkName: "shortcuts-page" */ './shortcutsPage'
      ).then(({ shortcutsPage }) => {
        return shortcutsPage.call(this, ...args);
      });
    },
    shortcutsOverlayPage: function (...args) {
      return import(
        /* webpackChunkName: "shortcuts-overlay-page" */ './shortcutsOverlayPage'
      ).then(({ shortcutsOverlayPage }) => {
        return shortcutsOverlayPage.call(this, ...args);
      });
    },
    blankPage: function (...args) {
      return import(/* webpackChunkName: "blank-page" */ './blankPage').then(
        ({ blankPage }) => {
          return blankPage.call(this, ...args);
        },
      );
    },
    selectOrgToUpgradePage: function (...args) {
      return import(
        /* webpackChunkName: "select-org-to-upgrade-page" */ './selectOrgToUpgradePage'
      ).then(({ selectOrgToUpgradePage }) => {
        return selectOrgToUpgradePage.call(this, ...args);
      });
    },
    selectTeamToUpgradePage: function (...args) {
      return import(
        /* webpackChunkName: "select-team-to-upgrade-page" */ './selectTeamToUpgradePage'
      ).then(({ selectTeamToUpgradePage }) => {
        return selectTeamToUpgradePage.call(this, ...args);
      });
    },
    searchPage: function (...args) {
      return import(/* webpackChunkName: "search-page" */ './searchPage').then(
        ({ searchPage }) => {
          return searchPage.call(this, ...args);
        },
      );
    },
    templatesGallerySubmitPage: function (...args) {
      return import(
        /* webpackChunkName: "templates-gallery-submit-page" */ './templatesGallerySubmitPage'
      ).then(({ templatesGallerySubmitPage }) => {
        return templatesGallerySubmitPage.call(this, ...args);
      });
    },
    templatesGalleryPublicPage: function (...args) {
      return import(
        /* webpackChunkName: "templates-gallery-public-page" */ './templatesGalleryPublicPage'
      ).then(({ templatesGalleryPublicPage }) => {
        return templatesGalleryPublicPage.call(this, ...args);
      });
    },
  },
  require('./invitation-routes'),
  require('./board-routes'),
  userOrOrgRoutes,
  {
    routes: [
      [ENTERPRISE_ADMIN, 'enterpriseAdminDashboardView'],
      [ENTERPRISE_ADMIN_TAB, 'enterpriseDashTab'],
    ],
    enterpriseAdminDashboardView: function (...args) {
      return import(
        /* webpackChunkName: "enterprise-admin-dashboard-page" */ './enterpriseAdminDashboardPage'
      ).then(({ enterpriseAdminDashboardPage }) => {
        return enterpriseAdminDashboardPage.call(this, ...args);
      });
    },
    enterpriseDashTab: function (...args) {
      return import(
        /* webpackChunkName: "enterprise-admin-dashboard-page" */ './enterpriseAdminDashboardPage'
      ).then(({ enterpriseAdminDashboardPage }) => {
        return enterpriseAdminDashboardPage.call(this, ...args);
      });
    },
  },
  require('./member-routes'),
  require('./organization-routes'),
  {
    routes: [[ERROR_PAGE, 'displayErrorPage']],
    displayErrorPage: function (...args) {
      return import(/* webpackChunkName: "error-page" */ './errorPage').then(
        ({ errorPage }) => {
          return errorPage.call(this, ...args);
        },
      );
    },
  },
];

const routes = _.chain(components)
  .map(function (component) {
    _.extend(Controller.prototype, component);
    delete Controller.prototype.routes;
    return component.routes;
  })
  .compact()
  .flatten(true)
  .value()
  .reverse(); // https://github.com/jashkenas/backbone/issues/1463

const singleton = new Controller();

routes.forEach(function ([route, name]) {
  return singleton.route(route, name);
});

module.exports = singleton;
